//DATA
export const THESAURI_SAVED = 'THESAURI_SAVED';
export const SET_THESAURIS = 'SET_THESAURIS';